import React from "react";
import { Typography } from "@mui/material";
import formatDate from "./formatDate";
import formatCurrency from "./formatCurrency";
import formatPercentage from "./formatPercentage";
import formatInt from "./formatInt";
import Spacer from "./Spacer";
import VerticalSpacer from "./VerticalSpacer";
import Link from "@mui/material/Link";
import DownloadField from "./DownloadField";

const LabelAttachedField = ({ ...props }) => {
  const { title, list, appId } = props;
  const titlePosition = props.titlePosition
    ? props.titlePosition
    : "left"; /* left, top */
  return (
    <Typography variant="body2" color="textSecondary" gutterBottom>
      <label
        style={{
          width: "200px",
          height: "auto",
          display: "block",
          fontWeight: "bold",
          //   float: "left",
          float: titlePosition == "left" ? "left" : "none",
        }}
      >
        {title ? title : "Documents"}:{" "}
      </label>
      <label
        style={{
          width: "400px",
          height: "auto",
          display: "block",
          float: "left",
        }}
      >
        {list.map((item) => (
          // <Link href={item.id} style={{ textDecoration: 'none','display':'block'}} >
          //         {item.filename}
          // </Link>
          <DownloadField
            docId={item.id}
            docType="filetypexxx"
            docFileName={item.filename}
            appId={appId}
            showIcon="false"
          />
        ))}
      </label>
    </Typography>
  );
};

export default LabelAttachedField;
